<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import {
        AUTHENTICATION,
        Button,
        InputEmail,
        InputMobile,
        InputOrganizationName,
        InputUrl,
        InputUserName,
        Link,
        Paragraph,
        RegistrationForm,
    } from '@smatch/cassiopeia-web-components';

    // CONFIG
    import { PRIVACY_STATEMENT_URL, TERMS_URL } from 'src/config';

    /* EXPORTS --------------------------------------------------------------------------------- */

    export let loginUrl = '/';

    /* INTERNALS -------------------------------------------------------------------------------- */

    $AUTHENTICATION.domain = 'buyer';

    // This needs to be cached, to ensure that the email field doesn't disappear on input
    const HAS_EMAIL = $AUTHENTICATION.email !== undefined;

</script>

<RegistrationForm on:success>

    <InputUserName bind:value = { $AUTHENTICATION.name } />

    {#if !HAS_EMAIL}
        <InputEmail bind:value = { $AUTHENTICATION.email } />
    {/if}

    <InputOrganizationName bind:value = { $AUTHENTICATION.companyName } />
    <InputUrl bind:value = { $AUTHENTICATION.url } isRequired = { false }/>
    <InputMobile bind:value = { $AUTHENTICATION.mobile } isRequired = { true }/>

    <Paragraph css = 'mt-2' align = 'center'>
        By signing up you agree to smatch’s <Link label = 'Terms' url = { TERMS_URL } css = 'underline' />
        and <Link url = { PRIVACY_STATEMENT_URL } css = 'underline' label = 'Privacy Policy'/>.
    </Paragraph>

    <Button
        type = 'submit'
        size = 'lg'
        icon = 'arrowRight'
        label = 'component.session.registration.submit_button'
        css = 'w-full'
    />

    <Paragraph css = 'mt-6' align = 'center'>

        Already Have an Account?

        <Link
            url = { loginUrl }
            label = 'component.session.registration.login_link'
            css = 'underline'
        />

    </Paragraph>

</RegistrationForm>